@if (updated() > 0) {
  <span class="badge-header">
    <span class="badge-header__count" title="Aktualisierungen ausgewählt">
      <mat-icon class="badge-header__icon">update</mat-icon> {{ updated() }} / {{ available() }}</span
    >
    <span class="badge-header__label">Aktualisierungen ausgewählt</span>
  </span>
} @else {
  <span class="badge-header">
    <span class="badge-header__count" title="Aktualisierungen verfügbar">
      <mat-icon class="badge-header__icon">update</mat-icon> {{ available() }}</span
    >
    <span class="badge-header__label">Aktualisierungen verfügbar</span>
  </span>
}
